export const PROGRAM_RESET_STATE = 'PROGRAM_RESET_STATE';
export const PROGRAM_CURRENT_ITEM = 'PROGRAM_CURRENT_ITEM';

export const PROGRAM_REQUEST_LOADING = 'PROGRAM_REQUEST_LOADING';
export const PROGRAM_REQUEST_SUCCESS = 'PROGRAM_REQUEST_SUCCESS';
export const PROGRAM_REQUEST_FAILED = 'PROGRAM_REQUEST_FAILED';

export const PROGRAM_CURRENT_ACTION = 'PROGRAM_CURRENT_ACTION';
export const PROGRAM_RESET_ACTION = 'PROGRAM_RESET_ACTION';